// eslint-disable-next-line no-restricted-imports
import { ChangeBanStatus } from "@skylords/api-client";

export { ChangeBanStatus };
export import BanStatus = ChangeBanStatus.BanStatusEnum;
